import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import Modal from '@mui/material/Modal';

import api from '../util/api';

// keep track globally to prevent multiple submissions
const cooldown = new Set();

export default class GuildModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: false
        };
    }

    endpoint = () => {
        return 'guilds/' + encodeURIComponent(this.props.guild?.region) + '/' + encodeURIComponent(this.props.guild?.realm) + '/' + encodeURIComponent(this.props.guild?.name);
    }

    refreshGuild = async (event) => {
        if (event) event.preventDefault(); // prevent form submission

        this.setState({ status: 'loading' });

        const endpoint = this.endpoint();
        const payload = { refresh: true };
        await api.post(endpoint, payload);

        cooldown.add(endpoint);
        this.setState({ status: false });
        this.props.onClose();

        return false;
    }

    render() {
        return (
            <Modal open={Boolean(this.props.guild?.name)} onClose={this.props.onClose}>
                <div className="card rounded" style={{ position: 'absolute', top: '50%', left: '50%', width: '25%', transform: 'translate(-50%, -50%)' }}>
                    <div className="card-header text-center">Import Guild Roster</div>
                    <div className="text-center">
                        <div className="mb-3">
                            {this.props.guild?.name}
                        </div>
                        <div className="mb-3">
                            You can import your guild roster to load any missing characters into <i>Data for Azeroth</i>. They
                            will be loaded in the background and speed will depend on server capacity. Please note
                            this will not refresh any existing characters.
                        </div>
                        <div className="btn-group mb-3">
                            {cooldown.has(this.endpoint()) ? <button disabled={true} className="btn btn-primary">Added to Queue</button> :
                            <form method="post" onSubmit={this.refreshGuild}>
                                <button type="submit" disabled={this.state.status} className="btn btn-primary">{this.state.status ? <FontAwesomeIcon icon={faSync} spin={true} /> : 'Import'}</button>
                            </form>}
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}